import React from "react";
import First from "./Web/First";
import Second from "./Web/Second";
import Third from "./Web/Third";

const WebTrainig = () => {
  return (
    <div>
      <First />
      <Second />
      <Third />
    </div>
  );
};

export default WebTrainig;
